import { IInterval } from "../../../../Context/Interval";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { LogGroup, CreateElement, Scale, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
import { Settings } from "../../../../Settings";

export class DiamondSpinSlideDoubleSlide extends Slide {
	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;

    protected title: HTMLElement = null;
    protected precoiusSpininstruction: HTMLElement = null;
    protected trigger: HTMLElement = null;

    protected diamondSpinPath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/DiamondSpin/";

    protected SripiteTimerLeft: IInterval;

    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize: Size) {
        super(initData, p , viewSize);

        this.logGroup = 	 this.p.logGroup.Add("DiamondSpinSlideDoubleSlide");
		this.resid = 		 this.p.resid.Add("DiamondSpinSlideDoubleSlide");
        this.viewSize = viewSize;

        this.view = CreateElement("div", {
            classes: ["DiamondSpinSlide", this.resid.Scope()],
            style: {
                position: "absolute",
                height: this.viewSize.Height + "px",
                width: this.viewSize.Width + "px",

                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
            }
        });
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

    }


    public override View(): HTMLElement {
        return this.view;
    }

    public override Update() {

    }



    public override Start() {

    }

    public override Stop() {

    }

}